import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/Tooltip";

const QuestionHelpIcon = ({ size = 16, details }) => {
    return (
        <Tooltip>
            <TooltipTrigger>
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6.06004 5.99968C6.21678 5.55412 6.52614 5.17841 6.93334 4.9391C7.34055 4.69978 7.81931 4.6123 8.28483 4.69215C8.75035 4.772 9.17259 5.01402 9.47676 5.37536C9.78093 5.7367 9.94741 6.19402 9.94671 6.66634C9.94671 7.99968 7.94671 8.66634 7.94671 8.66634M8.00004 11.333H8.00671M14.6667 7.99968C14.6667 11.6816 11.6819 14.6663 8.00004 14.6663C4.31814 14.6663 1.33337 11.6816 1.33337 7.99968C1.33337 4.31778 4.31814 1.33301 8.00004 1.33301C11.6819 1.33301 14.6667 4.31778 14.6667 7.99968Z"
                        stroke="#9396B4"
                        strokeWidth="0.888889"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </TooltipTrigger>
            <TooltipContent>{details}</TooltipContent>
        </Tooltip>
    );
};

export default QuestionHelpIcon;